<template>
  <v-simple-table>
    <template v-slot:default>
      <tbody>
        <tr v-for="item in details" :key="item.name">
          <td>
            <b>{{ item.name }}</b>
          </td>
          <td>{{ item.value }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  props: {
    item: Object // ao object passed from AoDetails component
  },
  mounted: async function() {
    this.section = this.$route.params.section;
    this.id = this.$route.query.id;

    await this.getCountries(); // wait for the countries to load first or else it won't show on the table
    this.getAo();
  },
  data() {
    return {
      details: [],
      countries: [],
      mapper: [
        {
          name: "AO Code",
          mapTo: "code"
        },
        {
          name: "AO Name",
          mapTo: "name"
        },
        {
          name: "First Approved Date",
          mapTo: "firstApprovedDate"
        },
        {
          name: "RenewalDate",
          mapTo: "renewalDate"
        },
        {
          name: "Status",
          mapTo: "status"
        },
        {
          name: "Address Line 1",
          mapTo: "addressLine1"
        },
        {
          name: "Address Line 2",
          mapTo: "addressLine2"
        },
        {
          name: "Address Line 3",
          mapTo: "addressLine3"
        },
        {
          name: "AO City",
          mapTo: "city"
        },
        {
          name: "Post Code",
          mapTo: "postcode"
        },
        {
          name: "Country",
          mapTo: "country"
        },
        {
          name: "Main Contact First Name",
          mapTo: "mainContactFirstName"
        },
        {
          name: "Main Contact Middle Name",
          mapTo: "mainContactMiddleName"
        },
        {
          name: "Main Contact Last Name",
          mapTo: "mainContactLastName"
        },
        {
          name: "Main Contact Email",
          mapTo: "mainContactEmail"
        },
        {
          name: "Main Contact Telephone",
          mapTo: "mainContactTelephone"
        },
        {
          name: "Main Contact Mobile",
          mapTo: "mainContactMobile"
        },
        {
          name: "Admin Contact Email",
          mapTo: "adminContactEmail"
        },
        {
          name: "Admin Contact Telephone",
          mapTo: "adminContactTelephone"
        },
        {
          name: "Admin Contact Mobile",
          mapTo: "adminContactMobile"
        },
        {
          name: "Account Contact Email",
          mapTo: "accountContactEmail"
        },
        {
          name: "Account Contact Telephone",
          mapTo: "accountContactTelephone"
        },
        {
          name: "Account Contact Mobile",
          mapTo: "accountContactMobile"
        }
      ]
    };
  },
  methods: {
    getCountries: function() {
      const promise = fetch(`${process.env.VUE_APP_ROOT_API}/countries`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
        .then(response => response.json())
        .then(data => {
          this.countries = data.countries;
        })
        .catch(error => {
          console.error(error);
        });

      return promise;
    },
    mapCountryIdToName: function(countryId) {
      for (let i = 0; i < this.countries.length; i++) {
        if (countryId == this.countries[i]._id) {
          return this.countries[i].name;
        }
      }
    },
    getAo: function() {
      // execute for new ao summary
      if (this.item) {
        this.writeToTable(this.item);
        return;
      }
      // execute for existing ao summary
      fetch(`${process.env.VUE_APP_ROOT_API}/ao/${this.id}`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
        .then(response => response.json())
        .then(data => {
          data.ao.country = this.mapCountryIdToName(data.ao.country);
          this.writeToTable(data.ao);
        })
        .catch(error => {
          console.error(error);
        });
    },

    writeToTable: function(item) {
      // to arrange the details to summary table in the desirable order
      this.mapper.map(key => {
        Object.keys(item).map(i => {
          if (key.mapTo == i) {
            this.details.push({ name: key.name, value: item[i] });
          }
        });
      });
    }
  }
};
</script>

<style scoped>
</style>